import type { WorkOrderTemplate } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/wo-template/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

export const createFields: FormItem<WorkOrderTemplate>[] = [
  {
    cssClass: 'tmm-section-no-background',
    caption: 'Work Order Template Details',
    colCount: {
      xs: 1,
      sm: 1,
      md: 2,
      lg: 2,
    },
    items: [allFields.tenantId] as FormItem<WorkOrderTemplate>[],
  },
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: {
      xs: 1,
      sm: 1,
      md: 6,
      lg: 6,
    },
    items: [
      { ...allFields.title, colSpan: 3 },
      { ...allFields.executionInterval, colSpan: 3 },
      { ...allFields.category, colSpan: 3 },
      { ...allFields.type, colSpan: 3 },
      { ...allFields.impact, colSpan: 2 },
      { ...allFields.priority, colSpan: 2 },
      { ...allFields.assignedTo, colSpan: 2 },
      { ...allFields.estimatedCostValue, colSpan: 3 },
      { ...allFields.estimatedEffort, colSpan: 3 },
      { ...allFields.description, colSpan: 6 },
      { ...allFields.notes, colSpan: 6 },
    ] as FormItem<WorkOrderTemplate>[],
  },
  {
    cssClass: 'tmm-section',
    caption: 'Classification',
    colCount: {
      xs: 1,
      sm: 1,
      md: 3,
      lg: 3,
    },
    items: [
      allFields.assetTypeId,
      allFields.assetManufacturerId,
      allFields.assetModelId,
    ] as FormItem<WorkOrderTemplate>[],
  },
];

export const updateFields: FormItem<WorkOrderTemplate>[] = [
  {
    cssClass: 'tmm-section-no-background',
    caption: 'Work Order Template Details',
    colCount: {
      xs: 1,
      sm: 1,
      md: 2,
      lg: 2,
    },
    items: [allFields.tenantId] as FormItem<WorkOrderTemplate>[],
  },
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: {
      xs: 1,
      sm: 1,
      md: 6,
      lg: 6,
    },
    items: [
      { ...allFields.title, colSpan: 3 },
      { ...allFields.displayNumber, colSpan: 3 },
      { ...allFields.executionInterval, colSpan: 2 },
      { ...allFields.category, colSpan: 2 },
      { ...allFields.type, colSpan: 2 },
      { ...allFields.impact, colSpan: 2 },
      { ...allFields.priority, colSpan: 2 },
      { ...allFields.assignedTo, colSpan: 2 },
      { ...allFields.estimatedCostValue, colSpan: 3 },
      { ...allFields.estimatedEffort, colSpan: 3 },
      { ...allFields.description, colSpan: 6 },
      { ...allFields.notes, colSpan: 6 },
    ] as FormItem<WorkOrderTemplate>[],
  },
  {
    cssClass: 'tmm-section',
    caption: 'Classification',
    colCount: {
      xs: 1,
      sm: 1,
      md: 3,
      lg: 3,
    },
    items: [
      allFields.assetTypeId,
      allFields.assetManufacturerId,
      allFields.assetModelId,
    ] as FormItem<WorkOrderTemplate>[],
  },
  getHistorySection(),
];
